import type { UseQueryResult } from "@tanstack/react-query";
import type { AssignedAgentsQueryData } from "web_myplann/Api/Advisor/Types/AssignedAgentsQueryData";

type AssignedAgentsQueryState = Pick<
	UseQueryResult<AssignedAgentsQueryData>,
	"data" | "isLoading"
>;

export const mapAdvisorsQueries = ([connectedQuery, pendingQuery]: readonly [
	AssignedAgentsQueryState,
	AssignedAgentsQueryState,
]) => ({
	data:
		connectedQuery.data && pendingQuery.data
			? {
					connectedAdvisors: connectedQuery.data.data,
					pendingAdvisors: pendingQuery.data.data,
					advisorsPending: pendingQuery.data.meta.totalCount,
				}
			: undefined,
	isLoading: connectedQuery.isLoading || pendingQuery.isLoading,
});
